import { formatISO } from 'date-fns';
import { EventSchedule } from 'src/types/dto';

import { EventScheduleValue } from './types/types';

export const eventScheduleApiToString = (value: EventSchedule) =>
	eventScheduleToString({ startDate: value.start, endDate: value.end });

export const eventScheduleToString = (value: EventScheduleValue) => {
	if (!value.startTime && !value.endTime) {
		return value.startDate && value.endDate
			? `${formatISO(new Date(value.startDate))}_${formatISO(
					new Date(value.endDate)
				)}`
			: '';
	} else {
		return value.startDate && value.endDate && value.startTime && value.endTime
			? `${formatISO(
					new Date(`${value.startDate}T${value.startTime}`)
				)}_${formatISO(new Date(`${value.endDate}T${value.endTime}`))}`
			: '';
	}
};

export const toEventSchedule = (value: string): EventScheduleValue => {
	const parts = value.split('_');
	return { startDate: parts[0], endDate: parts[1] };
};

let scheduleSequencial = 0;

export const sequences = {
	schedule: () => ++scheduleSequencial,
};
